export default __webpack_public_path__ + "static/media/manarp.9644bf2f.svg";